import ajax from "@/libs/Ajax";

let NAME_SPACE = "/aseapi/console/monitor";
export default {
    query(params) {
        return ajax.get(`${NAME_SPACE}/query`, {params});
    },
    start(data) {
        return ajax.post(`${NAME_SPACE}/start`, data);
    },
    stop(data) {
        return ajax.post(`${NAME_SPACE}/stop/`, data);
    },
    startAll() {
        return ajax.get(`${NAME_SPACE}/startAll`);
    },
    stopAll() {
        return ajax.get(`${NAME_SPACE}/stopAll`);
    },
};
